module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/priority-issue/priority-issue.component.css
// module id = ./src/app/reports/priority-issue/priority-issue.component.css
// module chunks = main